import { CalculatedTaskStatus } from '@lmc/ts-common';
import { TaskFiltersValue } from '../components/TaskFilters/TaskFilters';

export type AllFilters = TaskFiltersValue & {
  search?: string
}

export const convertPropsToParams = (props: Pick<AllFilters, 'categories' | 'residents' | 'categoryItems' | 'status' | 'rangePicker' | 'search'> | undefined) => ({
  to: props?.rangePicker?.[1]?.endOf('day').toISOString(),
  residents: props?.residents,
  categories: props?.categories,
  items: props?.categoryItems,
  status: props?.status as CalculatedTaskStatus[],
  title: props?.search,
})